import Data from 'app-core/Data';
import _ from 'lodash';
import storage from 'storage';

async function getParamParentService(param, servicesList) {	
	servicesList = servicesList || (await Data.getExternalServices(0, 9999, { baseServices: true })).Results;
	return param.ParentServiceOid ? servicesList.find(f => f.Oid === param.ParentServiceOid) : null;
}

async function getEditableParameters(service, nestedService, array, servicesList, allParams) {	
	servicesList = servicesList || (await Data.getExternalServices(0, 9999, { baseServices: true })).Results;
	return getEditableParametersSync(service, nestedService, array, servicesList, allParams);
}

function getEditableParametersSync(service, nestedService, array, servicesList, allParams) {
	array = array || [];

	const currentService = (nestedService || service);
	if (currentService.JsonDefinition.Parameters.length) {
		currentService.JsonDefinition.Parameters.map(p => {
			if (p.UserEditable && !array.includes(p.Name) && (allParams || service.JsonDefinition.Parameters.some(sp => sp.Name === p.Name))) {
				array.push(p.Name);
			}

			if (__DEBUG__)
				console.debug(`Check ${p.Name}`);

			if (p.ParentServiceOid) {
				const baseService = servicesList.find(s => s.Oid === p.ParentServiceOid);
				if (__DEBUG__)
					console.debug('Service', { baseService, servicesList, p });
				if (baseService)
					getEditableParametersSync(service, baseService, array, servicesList, allParams);
			}
		});
	}

	return array;
}

async function getParentEditableParameters(param, array, servicesList, structureArray) {
	servicesList = servicesList || (await Data.getExternalServices(0, 9999, { baseServices: true })).Results;
	return getParentEditableParametersSync(param, array, servicesList, structureArray);
}

function getParentEditableParametersSync(param, array, servicesList, structureArray, strucutreLevel) {
	array = array || [];	
	if (param.ParentServiceOid) {
		const baseService = servicesList.find(s => s.Oid === param.ParentServiceOid);
		if (baseService) {
			baseService.JsonDefinition.Parameters.map(p => {
				if (p.UserEditable && !array.includes(p.Name)) {
					array.push(p.Name);

					if (structureArray) {
						strucutreLevel = strucutreLevel || 0;
						if (!structureArray[strucutreLevel]) {
							structureArray[strucutreLevel] = [];
						}
						structureArray[strucutreLevel].push({
							service: baseService,
							param: p
						});
					}
				}

				if (p.ParentServiceOid) {
					getParentEditableParametersSync(p, array, servicesList, structureArray, (strucutreLevel || 0) + 1);
				}
			})
		}
	}
	return array;
}

function isSupportedTemplateFieldForParam(templateField, param, isComplex) {
	return (isComplex ? (templateField.dataType === param.Type) : (!templateField.isComplex && (!templateField.parentServiceOid && !param.ParentServiceOid || templateField.parentServiceOid === param.ParentServiceOid)));
}

function getTemplateFieldFromParam(param) {
	const templateField = {
		id: Data.formatStringAsKey(param.Name),
		description: param?.Caption || param.Name,
		default: param.Value,
		services: []
	}
	const isComplex = !!param.Keys;
	if (isComplex) {
		templateField.dataType = param.Type;
		templateField.isComplex = true;
	} else if (param.ParentServiceOid) {
		templateField.dataType = 'service';
		templateField.parentServiceOid = param.ParentServiceOid;
		templateField.parentServiceOutput = param.ParentServiceOutput;
	} else {
		templateField.dataType = param.DataType;
		if (['list', 'range'].includes(param.DataType)) {
			templateField.sourceParam = {
				name: param.Name,
				serviceId: param.__service?.Oid
			}
		}
		templateField.services.push({
			Name: param.Name,
			Value: param.Value
		})
	}

	if (__DEBUG__)
		console.debug('getTemplateFieldFromParam', { param, templateField });

	return templateField;
}

async function getParamFromTemplateField(templateField) {
	const param = {
		Name: templateField.id,
		Caption: templateField.description,
		DataType: 'string',
		Value: templateField.default
	}
	if (templateField.isComplex) {
		const complexParam = Data.complexExternalServicesTypes[templateField.dataType];
		param.Keys = [...(complexParam.default || [])];
		param.Type = templateField.dataType;
		param.Caption = templateField.description;
	} else if (templateField.parentServiceOid) {
		param.ParentServiceOid = templateField.parentServiceOid;
		param.ParentServiceOutput = templateField.parentServiceOutput;
	} else {
		param.DataType = templateField.dataType || 'string';
		param.IsMemo = templateField.isMemo;
		if (templateField.sourceParam && ['list', 'range'].includes(templateField.dataType)) {
			const service = await Data.getExternalService(templateField.sourceParam.serviceId);
			const sourceParam = service?.JsonDefinition.Parameters.find(f => f.Name === templateField.sourceParam.name);
			if (sourceParam) {
				param.ListOptions = _.cloneDeep(sourceParam.ListOptions);
				param.MultiSelect = sourceParam.MultiSelect;
			}
		}
	}

	if (__DEBUG__)
		console.debug(`getParamFromTemplateField ${param.Name}`, { param });

	return param;
}

function getLastUsedParamsForService(service, defParams, defParamsCaptions) {
	const lastUsedParameters = storage.prop(`StructureCriteriaLastUsedParamsVer2_${service.Oid}`, void 0, {
		paramValues: _.cloneDeep(defParams) || {},
		paramCaptions: _.cloneDeep(defParamsCaptions) || {},
	});
	return lastUsedParameters;
}

function getCriteriaFields() {
	return Data.getExternalServices(0, 9999).then(async r => {
		let criteriaFields = [];
		let services = [];
		r.Results.map(async f => f.JsonDefinition && services.push({ ...f.JsonDefinition, Oid: f.Oid, Name: f.Name, Category: f.Category, instance: f }));

		const operations = {
			'string':	[ 'contains', 'notcontains', 'startswith', 'endswith', '=', '<>' ],
			'numeric':	[ '=', '<>', '<', '>', '<=', '>=' ],
			'number':	[ '=', '<>', '<', '>', '<=', '>=' ],
			'date':     [ '=', '<>', '<', '>', '<=', '>=' ],
			'datetime':	[ '=', '<>', '<', '>', '<=', '>=' ],
			'boolean':	[ '=', '<>' ],
			'object':	[ 'isblank', 'isnotblank' ],
			'list':     [ '=', '<>', ],
			'range':    [ '=', '<>', ]
		}

		services.filter(f => f.Outputs?.length).map(f => {
			let lastStruct = f.Category > 0 ? `category_${f.Category}` : '';

			lastStruct += `${lastStruct ? '.' : ''}service_${f.Oid}`;
			criteriaFields.push({
				dataField: lastStruct,
				caption: f.Name,
				filterOperations: ['isnotblank']
			});

			f.Outputs.map(p => {
				criteriaFields.push({
					dataField: `${lastStruct}.output_${p.Name}`,
					caption: p.Name,
					editorTemplate: 'output-template',
					param: p,
					dataType: p.DataType === 'list' || p.DataType === 'range' ? 'string' : p.DataType,
					filterOperations: operations[p.DataType],
					lookup: p.DataType === 'list' || p.DataType === 'range' ? {
						dataSource: p.ListOptions.map(f => ({ key: f.Key, value: f.Value || f.Key })),
						allowClearing: true,
						displayExpr: 'value',
						valueExpr: 'key'
					} : null
				});
			})
		});

		if (__DEBUG__)
			console.debug('Services loaded', { services: services, criteriaFields });

		return {
			services,
			criteriaFields
		}	
	});
}

function fixRootElements(model, criteriaFields) {
	if (__DEBUG__)
		console.debug('fixRootElements', { model });

	let check = (f) => {
		if (Array.isArray(f)) {
			if (typeof(f[0]) === 'string' && `${f[0]}`.startsWith('service_')) {
				let id = f[0];
				let field = criteriaFields.find(f => f.dataField === id);
				if (!field?.param) {
					let newField = criteriaFields.find(c => `${c.dataField}`.startsWith(id) && c.param);
					if (newField) {
						let newId = newField?.dataField;
						f[0] = newId;
						f[1] = newField.filterOperations[0];
						f[2] = f[2] || '';

						if (__DEBUG__)
							console.debug('fixRootElementsIfSelected Fixed', { id, newId, newField, f });
					}
				}
			} else {
				f.map((v, i) => {
					f[i] = check(v);
				});
			}
		}

		return f;
	}

	return check(model);
}

export default {
	getEditableParameters,
	getEditableParametersSync,
	getParentEditableParameters,
	getParentEditableParametersSync,
	isSupportedTemplateFieldForParam,
	getTemplateFieldFromParam,
	getParamFromTemplateField,
	getLastUsedParamsForService,
	getParamParentService,
	getCriteriaFields,
	fixRootElements
};
